import * as React from 'react';
import { Router, Route, hashHistory } from 'react-router';
import { GenericBlocker } from './GenericBlocker';

export const BlockerApp = () => (
  <div className="BlockerApp">
    <Router history={hashHistory}>
      <Route path="/(:reason)" component={GenericBlocker} />
    </Router>
  </div>
);
